import React from "react";
import ReactHtmlParser from "react-html-parser";
import Options from "./options";

//
// Here are all the options they can choose about what worries them
// about their driving
//
const Form = props => {
  // deconstruct objects sent as props
  const { item = [], onSelect, selectedChoices } = props;
  const { choices = [], nid } = item;
  return (
    // a workaround: for form content, use the content area to store the image for
    // the first column.
    <div>
      <div className="row columns-wrapper-25-75">
        <div className="columns column-uneven-1">
          {ReactHtmlParser(item.content)}
        </div>
        <div className="columns column-uneven-2">
          <h2 className="form-title">
            {item.track === "myself"
              ? "What worries you about your driving?"
              : "What worries you about an older adult's driving?"}
          </h2>
          <p>
            <strong>(check all that apply)</strong>
          </p>
          {choices.length > 0 && (
            <Options
              items={choices}
              onSelect={onSelect}
              qid={nid}
              selectedChoices={selectedChoices}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Form;
